<script setup lang="ts">
  import { computed } from "vue";

  interface StatsItem {
    name: string;
    title: string;
    screenout_rate?: number;
  }

  const props = defineProps<{
    title: string;
    items: StatsItem[];
    itemType: string;
    emptyMessage: string;
    variant?: "red" | "amber";
  }>();

  const borderColorClass = computed(() => {
    return props.variant === "amber" ? "border-status-warning" : "border-status-error";
  });

  function getRate(item: StatsItem): number {
    if (!item?.screenout_rate) return 0;
    return Math.round(item.screenout_rate * 100);
  }
</script>

<template>
  <section>
    <h3 class="heading-section mb-3">{{ title }}</h3>
    <ul
      v-if="items.length"
      class="space-y-3">
      <li
        v-for="(item, index) in items"
        :key="`${itemType}-${index}`"
        :class="['border-l-2 pl-3 py-1', borderColorClass]">
        <div class="flex items-center gap-2">
          <span class="font-semibold text-foreground text-sm"> {{ getRate(item) }}% </span>
          <span class="text-foreground/80 text-sm">{{ item.name }}</span>
        </div>
        <p class="text-foreground/60 text-xs mt-0.5">{{ item.title }}</p>
      </li>
    </ul>
    <p
      v-else
      class="text-sm text-foreground/50 italic">
      {{ emptyMessage }}
    </p>
  </section>
</template>
